import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "../axios";

const useAddAdminMutation = (options = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (adminData) => {
      const response = await axios.post("/api/auth/register", {
        first_name: adminData.first_name,
        last_name: adminData.last_name,
        email: adminData.email,
        role: adminData.role,
        verify: adminData.verify,
      });
      return response.data;
    },
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries(["admins"]);
      options.onSuccess?.(data, variables, context);
    },
  });
};

export default useAddAdminMutation;
